var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "v6/solid/bars"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.5 4.5C1.5 3.67172 2.17172 3 3 3H21C21.8297 3 22.5 3.67172 22.5 4.5C22.5 5.32969 21.8297 6 21 6H3C2.17172 6 1.5 5.32969 1.5 4.5ZM1.5 12C1.5 11.1703 2.17172 10.5 3 10.5H21C21.8297 10.5 22.5 11.1703 22.5 12C22.5 12.8297 21.8297 13.5 21 13.5H3C2.17172 13.5 1.5 12.8297 1.5 12ZM21 21H3C2.17172 21 1.5 20.3297 1.5 19.5C1.5 18.6703 2.17172 18 3 18H21C21.8297 18 22.5 18.6703 22.5 19.5C22.5 20.3297 21.8297 21 21 21Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBars);
export default __webpack_public_path__ + "static/media/bars.24a1cb0dc6a64af1cc7be1bac509092b.svg";
export { ForwardRef as ReactComponent };